import { stdObject } from "../../data/types/stdObject";

export interface DataState {
  user: object;
  usersList: object;
  routes: object;
  rol: Array<object>;
  listRow: stdObject;
  pai: Array<object>;
  imp: Array<object>;
  alm: Array<object>;
  suc: Array<object>;
  cat: Array<object>;
  for: Array<object>;
  bankAccounts: Array<object>;
  expenses: Array<object>;
  brands: Array<object>;
  are: Array<object>;
  areaLinks: Array<object>;
  areaUsers: Array<object>;
  hor: Array<object>;
  sda: Array<object>;
  art: stdObject;
  headers: object;
  tar: Array<object>;
  ta0: Array<object>;
  ctpa: Array<object>;
  vtpa: Array<object>;
  per: Array<object>;
  userAccess: object;
  sync: stdObject;
  sev: Array<object>;
  search: object;
  dictList: object;
  staff: Array<object>;
  rut: Array<object>;
  tal: Array<object>;
  pag: Array<object>;
}

export const initialState: DataState = {
  user: {},
  usersList: {},
  routes: {},
  rol: [],
  listRow: { type: false, data: [] },
  pai: [],
  imp: [],
  alm: [],
  suc: [],
  cat: [],
  for: [],
  bankAccounts: [],
  expenses: [],
  brands: [],
  are: [],
  areaLinks: [],
  areaUsers: [],
  hor: [],
  sda: [],
  art: {},
  headers: {},
  tar: [],
  ta0: [],
  ctpa: [],
  vtpa: [],
  per: [],
  userAccess: {},
  sync: {},
  sev: [],
  search: {},
  dictList: {},
  staff: [],
  rut: [],
  tal: [],
  pag: [],
};
